module.exports = __webpack_public_path__ + "img/order_bill.e7f2c059.png";